export const MuiInput = {
    styleOverrides: {
        root: ({ theme: { palette } }) => ({
            "&:hover:not(.Mui-focused)::before": {
                borderColor: palette.primary.light
            },
            "&.MuiInput-underline": {
                "&:hover:before": {
                    borderBottomWidth: "1px",
                    transition: "border-color 0.3s ease"
                },
                "&.Mui-error:hover:before": {
                    borderColor: palette.error.main
                },
                "&:after": {
                    borderBottomWidth: "1px"
                },
                "&:not(.Mui-error):not(.Mui-disabled):not(:hover):before": {
                    borderBottom: `1px solid ${palette.divider}`
                },
                "&.Mui-disabled:before": {
                    borderColor: palette.grey["200"]
                }
            }
        })
    }
};
//# sourceMappingURL=Input.js.map